<script>
    import FileUpload from './FileUpload';
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            'file-upload': FileUpload,
            'multiselect': Multiselect
        },
        name: "StepFour",
        props: {
            'course': Object,
            'responsible': Object,
            'audience': Object,
        },
        data() {
            return {
                languages: [],
                selected: null,
                checkedServices: null,
                loading: false,
                disabilities: [],
                services: [],
                imageMaxSize: 3, // megabytes
                validationError: {
                    name: false,
                    email: false
                }
            }
        },
        mounted() {
            axios({
                method: 'get',
                url: '/courses/' + this.course.courseId + '/services',
            }).then((response) => {
                this.services = response.data.services;
                this.checkedServices = response.data.checkedServices;
            }).catch((error) => {
                this.message = 'Error';
            });

            axios({
                method: 'get',
                url: '/courses/' + this.course.courseId + '/languages',
            }).then((response) => {
                this.languages = response.data.languages;
                this.selected = response.data.selected;
            }).catch((error) => {
                this.message = 'Error';
            });
        },
        methods: {
            isLoading() {
                return this.loading;
            },
            previousStep() {
                this.$emit('update-step', 3);
            },
            postForm() {
                var data = {};

                data['checkedServices'] = this.checkedServices;

                if (this.responsible.name && this.responsible.name !== 'null') {
                    data['name'] = this.responsible.name;
                }
                if (this.responsible.hasEmail) {
                    data['hasEmail'] = this.responsible.hasEmail;

                    if (this.responsible.email && this.responsible.email !== 'null') {
                        data['email'] = this.responsible.email;
                    }
                }

                data['languages'] = this.selected;

                this.loading = true;
                this.$bus.$emit('searching');

                axios({
                    method: 'put',
                    url: '/courses/' + this.course.courseId + '/services',
                    data: data,
                }).then((response) => {
                    this.loading = false;
                    this.$bus.$emit('filtered');
                    this.$emit('update-step', 5);
                }).catch((error) => {
                    this.loading = false;
                    this.$bus.$emit('filtered');
                    this.message = 'Error';
                });
            }
        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/course/StepFour.vue